<template>
  <form-button-group stretch>
    <form-button
      icon="plus"
      @click="toggle"
    >
      Adicionar veículo
    </form-button>

    <modal-base
      v-if="open"
      title="Adicionar veículo"
      center
      @close="toggle"
    >
      <form-button-group
        direction="vertical"
        stretch
      >
        <form-button :href="importing">
          Importar de um anúncio em outro site
        </form-button>

        <form-button :href="creating">
          Adicionar manualmente
        </form-button>
      </form-button-group>
    </modal-base>

    <filter-button
      :active="active"
      action="usedVehicles/filter"
    />
  </form-button-group>
</template>

<script>
  import { mapState } from 'vuex';

  import FilterButton from '@sdk/components/Filters/Button.vue';

  import FormButton from '@cordel/components/Form/Button.vue';
  import FormButtonGroup from '@cordel/components/Form/Button/Group.vue';

  import ModalBase from '@cordel/components/Modal/Base.vue';

  export default {
    name: 'VehiclesListFilter',
    components: {
      FormButton,
      FormButtonGroup,

      FilterButton,

      ModalBase,
    },
    data() {
      return {
        open: false,
      };
    },
    computed: {
      ...mapState([
        'usedVehicles',
      ]),

      active() {
        // eslint-disable-next-line no-underscore-dangle
        return this.usedVehicles.list.filters._active;
      },

      importing() {
        return {
          name: 'vehicles-new',
          query: {
            import: true,
          },
        };
      },

      creating() {
        return {
          name: 'vehicles-new',
        };
      },
    },
    methods: {
      toggle() {
        this.open = !this.open;
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '@cordel/assets/stylesheets/mixins/reset.scss';
  @import '@cordel/assets/stylesheets/variables/breakpoints.scss';
</style>
